import { render, staticRenderFns } from "./DeletedResources.vue?vue&type=template&id=b2813a4c&scoped=true"
import script from "./DeletedResources.vue?vue&type=script&lang=js"
export * from "./DeletedResources.vue?vue&type=script&lang=js"
import style0 from "./DeletedResources.vue?vue&type=style&index=0&id=b2813a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2813a4c",
  null
  
)

export default component.exports